export default __webpack_public_path__ + "static/media/s3.5b97e166.png";